import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startCheckout = async (gift = null) => {
  try {
    const { data } = await axios.post(`${API}/payments/checkout`, { origin_url: window.location.origin, gift });
    if (data?.checkout_url) { window.location.href = data.checkout_url; return true; }
    toast.error("Checkout is unavailable right now. Please try again.");
  } catch (e) {
    const msg = e?.response?.data?.detail?.[0]?.msg;
    toast.error(msg ? msg.replace("Value error, ", "") : "Checkout is unavailable right now. Please try again.");
  }
  return false;
};
